import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function OpenInNewOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"open_in_new_off"}/>
}
